module.exports = __webpack_public_path__ + "img/user.11ba489a.svg";